import { render, staticRenderFns } from "./BacLazyImage.vue?vue&type=template&id=0b28c05f&scoped=true&"
import script from "./BacLazyImage.vue?vue&type=script&lang=ts&"
export * from "./BacLazyImage.vue?vue&type=script&lang=ts&"
import style0 from "./BacLazyImage.vue?vue&type=style&index=0&id=0b28c05f&prod&lang=scss&scoped=true&"
import style1 from "./BacLazyImage.vue?vue&type=style&index=1&id=0b28c05f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b28c05f",
  null
  
)

export default component.exports